import { useContext, useState } from "react";
import { SettingsContext, ShopContext } from "../App";
import Label from "./Label";
import api from "./api/api";
import currencyFormat, { canShowReceiptButton, getStatusLabel, textLabel } from "./functions/functions";
import Moment from "react-moment";
import "../css/LocalHistory.css";
import OrderSheet from "./user/OrderSheet";
import OrderTicketsModal from "./OrderTicketsModal";

export default function LocalHistory() {
	const { history, setLocalHistoryVisible, setLoading, settings, monoOrder, labels, lang } = useContext(SettingsContext);
	const { shop } = useContext(ShopContext);
	const [order, setOrder] = useState(false);
	const [ticketsModalOrder, setTicketsModalOrder] = useState(null);

	const loadBillUrl = async (selectedOrder) => {
		if (shop?.scloby_active == 1) {
			setLoading(true);
			const response = await api.post("/orders/get_bill_url/" + selectedOrder.id + "/");
			setLoading(false);
			if (response.success == 0) {
				alert(response.error);
				return;
			}
			window.open(response.bill_url, "_blank");
			return;
		}

		setLoading(true);
		const response = await api.post("/orders/get/" + selectedOrder.id + "/");
		setLoading(false);
		if (response.success == 0) {
			alert(response.error);
			return;
		}
		const billUrl = typeof response.data?.bill_url === "string" ? response.data.bill_url.trim() : "";
		if (!billUrl) {
			alert(textLabel(labels, 173, lang) || "Scontrino non disponibile");
			return;
		}
		window.open(billUrl, "_blank");
	};

	return (
		<>
			<div className="local-history">
				<div className="local-history-content">
					<div className="local-history-header">
						<div>
							<Label number={76} />
						</div>
						<button
							className="local-history-header-close-button"
							onClick={() => setLocalHistoryVisible(false)}
						>
							&times;
						</button>
					</div>
					<div className="local-history-scroll">
						{history.length == 0 ? (
							<div className="text-center"><Label number={174} /></div>
						) : (
							history.map((order, i) => (
								<div key={i}>
									<div className="local-history-line">
										<div>
											<div className="bold">
												<Label number={175} /> {order.number ? `N.${order.number} - ` : ""}ID:{order.id}
											</div>
											<div className="small">
												<Moment format={"DD/MM/YYYY LT"} locale="it">
													{order.delivery_date}
												</Moment>
											</div>
											{(order.name || order.email) && (
												<div className="small local-history-contact">
													{order.name && (
														<div>
															<Label number={189} />: <strong>{order.name}</strong>
														</div>
													)}
													{order.email && (
														<div>
															Email: <strong>{order.email}</strong>
														</div>
													)}
												</div>
											)}
										</div>
										<div className="small">
											<button
												className="basic-button"
												onClick={() => setOrder(order)}
											>
												<Label number={97} />
											</button>
											{canShowReceiptButton(order, shop) && (
												<button
													className="basic-button"
													onClick={() => loadBillUrl(order)}
												>
													<Label number={171} />
		</button>
											)}
											{settings?.selfordering?.enable_pickup_receipts_mono == 1 && (
												<button
													className="basic-button"
													onClick={() => setTicketsModalOrder(order)}
												>
													<Label number={156} />
												</button>
											)}
										</div>
									</div>
									<hr />
								</div>
							))
						)}
					</div>
				</div>
			</div>
			{ticketsModalOrder && (
				<OrderTicketsModal
					order={ticketsModalOrder}
					onClose={() => setTicketsModalOrder(null)}
				/>
			)}
			{order && (
				<div className="local-history">
					<div className="local-history-content">
						<div className="local-history-scroll">
							<OrderSheet
								order={order}
								setOrder={setOrder}
								loadBillUrl={loadBillUrl}
								showReceiptButton={canShowReceiptButton(order, shop)}
							/>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
